module.exports = __tmimport("~load:{controller: \"customized/api\", action: \"tracker_info\"}");